import { render, staticRenderFns } from "./TasksMaintenanceLift.vue?vue&type=template&id=5b03fb8b"
import script from "./TasksMaintenanceLift.vue?vue&type=script&lang=js"
export * from "./TasksMaintenanceLift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports